import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Container } from "./Knowledge.styled";
import { Breadcrumb } from "./components";
import { Main, KnowledgeHub } from "./pages";
import { Alert } from "@ann/web-components";
import { useKnowledgeBreadcrumbs } from "./hooks/useKnowledgeBreadcrumbs";

const Knowledge = () => {
  const { items: breadcrumbItems, helpers: breadcrumbHelpers } = useKnowledgeBreadcrumbs();

  const [error, setError] = useState(null);

  return (
    <Container>
      {/* <Breadcrumb items={breadcrumbItems} /> */}
      {error && (
        <Alert
          severity="error"
          description={error.message}
          closable
          onClose={() => setError(null)}
          style={{ marginBottom: "16px" }}
        />
      )}
      <Routes>
        <Route
          path="knowledge-hub/:knowledgeId/*"
          element={<KnowledgeHub breadcrumbHelpers={breadcrumbHelpers} />}
        />
        <Route path="/*" element={<Main breadcrumbHelpers={breadcrumbHelpers} />} />
      </Routes>
    </Container>
  );
};

export default Knowledge;

